import React, { useState } from "react";
import Icon1 from "../icons/Icon.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  updateDocDataField,
} from "../models/DataFunctions.js";

import { useAppContext } from "../config/AppContext.js";
import { useSnackbar } from "notistack";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import loadingAnimation from "../animations/loading.json"; // Path to your JSON file
import { Player } from "@lottiefiles/react-lottie-player";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import { Spin } from "antd";
import SmallSpinner from "../loading/SmallSpinner.js";
import createDocApi from "../api/database/createDocApi.js";
import createFolderOnOecVmc from "../api/oecvmc/createFolderOnOecVmc.js";
import { getRefFromId } from "../models/DataFunctions.js";
import JSZip from "jszip";
import updateDocApi from "../api/database/updateDocApi.js";

export const generateID = (prefix) => {
  let randomPart = Math.random().toString(36).substring(2, 30);
  //let date As 2025-04-12
  let date = new Date();
  let formattedDate = date.toISOString().split("T")[0].replace(/-/g, "");
  return `${prefix}_${formattedDate}_${randomPart}`;
};

const renderLogLines = (logs) => {
  const lines = logs.split("\n");
  const groups = [];
  let currentTableLines = [];

  const flushTable = () => {
    if (currentTableLines.length > 0) {
      groups.push({ type: "table", lines: currentTableLines });
      currentTableLines = [];
    }
  };

  lines.forEach((line) => {
    if (line.includes("|")) {
      currentTableLines.push(line);
    } else {
      flushTable();
      groups.push({ type: "text", line });
    }
  });
  flushTable();

  return groups.map((group, gi) => {
    if (group.type === "text") {
      const line = group.line;
      return (
        <div
          key={gi}
          className={
            line.includes("[ERROR]")
              ? "text-red-500 font-medium"
              : line.startsWith("---")
              ? "text-blue-500 font-medium mt-2 mb-1"
              : "text-shadow_50"
          }
        >
          {line}
        </div>
      );
    }
    // table group
    return (
      <table
        key={gi}
        className="w-full text-left border-collapse mb-1"
      >
        <tbody>
          {group.lines.map((line, li) => {
            const cells = line.split("|").map((c) => c.trim());
            return (
              <tr key={li} className="border-b border-neutral-100">
                {cells.map((cell, ci) => (
                  <td
                    key={ci}
                    className={`py-0.5 pr-3 ${
                      ci === 0
                        ? "font-medium text-neutral-700 whitespace-nowrap"
                        : "text-shadow_50"
                    }`}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  });
};

const NewMission = ({ document, folder, orgData, userData, onClose, onUpdate }) => {
  const [step, setStep] = useState("choice");

  const [allfields, setAllFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [path, setPath] = useState("");
  const [url, setUrl] = useState("");
  const [documents, setDocuments] = useState([]);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [operators, setOperators] = useState([]);
  const [operator, setOperator] = useState("");
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [loadingMission, setLoadingMission] = useState(false);
  const [extractionLogs, setExtractionLogs] = useState("");
  const [bookshelf, setBookshelf] = useState([]);
  const [maj, setMAJ] = useState(false);
  const [status, setStatus] = useState("inspection");
  const [devMode, setDevMode] = useState(false);
  const [devOecVmcUrl, setDevOecVmcUrl] = useState("http://127.0.0.1:8001");

  const types_of_work = ["Neuf", "Rénovation", "Extension", "Autre"];
  const reglementations = ["RT2012", "RE2020", "Autre"];
  const labels = ["Aucun", "Passif", "BBC Renovation", "Autre"];
  const [type_of_work, setTypeOfWork] = useState("Neuf");
  const [reglementation, setReglementation] = useState("RE2020");
  const [label, setLabel] = useState("Aucun");
  const all_status = [
    {
      value: "initialization",
      label: "Démarrage",
    },
    {
      value: "pré-inspection",
      label: "Pré-inspection",
    },
    {
      value: "inspection",
      label: "Inspection",
    },
  ];

  const [missions, setMissions] = useState([
    { value: "Mission Ventilation", label: "Mission Ventilation" },
  ]);
  const [mission, setMission] = useState("Mission Ventilation");
  const [all_files, setAllFiles] = useState([]);
  const [extra_files, setExtraFiles] = useState([]);
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const [vmc_documents, setVmcDocuments] = useState([
    {
      name: "Fichier XML (.zip ou .xml)",
      type: "xml",
      id: generateID("document"),
      file: null,

      key: "xml_file",
    },
    {
      name: "Dimensionnement réseaux VMC (.pdf)",
      type: "pdf",
      id: generateID("document"),
      file: null,
      key: "etude_vmc",
    },
  ]);

  const handleFetchData = async () => {
    if (orgData) {
      const docs = await getArrayDocDataByRef(folder.documents);
      const bookshelf = orgData.bookshelf_id
        ? await getDocDataById("bookshelf", orgData.bookshelf_id)
        : null;
      setBookshelf(bookshelf);
      setDocuments(docs);
      let members = [];
      if (folder.members_id) {
        members = await getArrayDocDataByID("user", folder.members_id);
      }

      const users = await getArrayDocDataByID("user", orgData.users_id);
      const operators = users.filter((user) => user.role === "operator");
      if (operators.length === 0) {
      }
      const operators_dict = operators.map((operator) => ({
        value: operator.id,
        label: operator.display_name,
      }));
      setOperators(operators_dict);
      const folderOperatorId = folder.members_id?.[0];
      setOperator(
        folderOperatorId && operators_dict.some((o) => o.value === folderOperatorId)
          ? folderOperatorId
          : operators_dict[0]?.value
      );
      setMission(missions[0].value);
      let all_files = [
        ...(folder.xml?.file ? [folder.xml.file] : []),
        ...folder.thermal?.files,
        ...docs.flatMap((doc) => doc.files || []),
        ...(bookshelf?.files_infiltrea || []),
      ];
      setAllFiles(all_files);

      if (folder.xml?.file) {
        let fresh_vmc_documents = [...vmc_documents];
        fresh_vmc_documents[0].file = folder.xml.file;
        setVmcDocuments(fresh_vmc_documents);
      }
      // if any file has vmc in its name, set it as default for etude_vmc
      let etude_vmc_file = all_files.find(
        (file) =>
          file.name.toLowerCase().includes("vmc") ||
          file.name.toLowerCase().includes("ventilati")
      );
      if (etude_vmc_file) {
        let fresh_vmc_documents = [...vmc_documents];
        fresh_vmc_documents[1].file = etude_vmc_file;
        setVmcDocuments(fresh_vmc_documents);
      }
    }
  };

  useEffect(() => {
    handleFetchData();
  }, [orgData]);

  function no_document() {
    return (
      folder?.thermal?.files?.length !== 0 ||
      documents.some((doc) => doc.files?.length > 0)
    );
  }
  const handleCreateMission = async () => {
    setLoadingMission(true);

    try {
      let operator_object = await getDocDataById("user", operator);
      let body = {
        created_at: getFlutterTime(),
        folder_id: folder.id,
        imported_file_name: document.name,
        folder_id: folder.id,
        folder_vmc_id: generateID("folder"),
        nom: folder.nom,
        user_email: operator_object.email,
        user_id: operator,
        org_id: orgData.id,
        type: mission,
        documents: [
          ...vmc_documents.filter((doc) => doc.file !== null),
          ...extra_files.map((file) => ({
            name: file.name,
            type: file.name.split(".").pop()?.toLowerCase() || "pdf",
            id: generateID("document"),
            file: file,
            key: "annexe",
          })),
        ],
        status: status,
        type_of_work: type_of_work,
        reglementation: reglementation,
        label: label,
        oecvmc_status: "pending",
      };
      let new_mission = await createDocApi("missionvmc", body, prefix);
      let missionvmc_ids = folder.missionvmc_ids || [];
      missionvmc_ids.push(new_mission.id);
      await updateDocApi(
        folder.ref,
        {
          missionvmc_ids: missionvmc_ids,
        },
        prefix
      );

      // Close modal immediately — OEC VMC processing continues in background
      handleClickVariant("Mission créée, traitement en cours sur OecVmc...", "info");
      onUpdate();
      onClose();

      // Fire OEC VMC call in background (no await blocking the UI)
      let mission_id = new_mission.id;
      const token = await getOrRefreshFirebaseToken();
      const devUrl = devMode ? devOecVmcUrl : null;
      createFolderOnOecVmc(mission_id, token, prefix, devUrl).then(async (res) => {
        const missionRef = getRefFromId("missionvmc", mission_id);
        if (res.success !== true) {
          await updateDocApi(missionRef, { oecvmc_status: "failed" }, prefix);
          handleClickVariant(
            "Erreur lors de la création de la mission sur OecVmc : " + res.detail,
            "error"
          );
        } else {
          const updateData = { oecvmc_status: "success" };
          if (res.extraction_logs) {
            updateData.extraction_logs = res.extraction_logs;
          }
          await updateDocApi(missionRef, updateData, prefix);
          handleClickVariant("Mission créée sur OecVmc avec succès", "success");
        }
        onUpdate();
      }).catch((e) => {
        console.error(e);
        const missionRef = getRefFromId("missionvmc", mission_id);
        updateDocApi(missionRef, { oecvmc_status: "failed" }, prefix);
        handleClickVariant("Erreur lors de la création de la mission", "error");
      });
    } catch (e) {
      console.error(e);
      handleClickVariant("Erreur lors de la création de la mission", "error");
      setLoadingMission(false);
    }
  };

  function no_xml() {
    return folder?.xml?.file?.id === undefined;
  }

  return (
    <div className="flex flex-col  bg-white rounded-xl max-w-c700">
      {step === "choice" && (
        <>
          <div className=" text-h2 p-4 border-b-1">
            Création de mission OecVmc
          </div>
          <div className="p-4 bg-neutral-50 flex flex-col">
            {!loadingMission && !extractionLogs && (
              <div className=" text-h3 text-shadow_50">
                Sélectionnez un type de mission pour créer une mission sur votre
                interface oecvmc à partir des informations du dossier.
              </div>
            )}

            {!loadingMission && !extractionLogs && (
              <>
                <div className="flex flex-row w-full gap-2 mt-4">
                  <div className="flex flex-col w-full gap-2">
                    <DropDownGPT03
                      transparent={false}
                      label="Type de mission"
                      className="w-full"
                      value={mission}
                      items={missions}
                      onChange={(e) => setMission(e.value)}
                    ></DropDownGPT03>
                    <DropDownGPT03
                      label="Opérateur"
                      transparent={false}
                      className="w-full"
                      value={operator}
                      items={operators}
                      onChange={(e) => setOperator(e.value)}
                    ></DropDownGPT03>
                    <DropDownGPT03
                      label="Status"
                      transparent={false}
                      className="w-full"
                      value={status}
                      items={all_status}
                      onChange={(e) => setStatus(e.value)}
                    ></DropDownGPT03>
                  </div>
                  <div className="flex flex-col w-full gap-2">
                    <DropDownGPT03
                      transparent={false}
                      label="Type de travaux"
                      className="w-full"
                      value={type_of_work}
                      items={types_of_work.map((type) => ({
                        value: type,
                        label: type,
                      }))}
                      onChange={(e) => setTypeOfWork(e.value)}
                    ></DropDownGPT03>
                    <DropDownGPT03
                      label="Réglementation"
                      transparent={false}
                      className="w-full"
                      value={reglementation}
                      items={reglementations.map((reg) => ({
                        value: reg,
                        label: reg,
                      }))}
                      onChange={(e) => setReglementation(e.value)}
                    ></DropDownGPT03>
                    <DropDownGPT03
                      label="Label"
                      transparent={false}
                      className="w-full "
                      value={label}
                      items={labels.map((lab) => ({
                        value: lab,
                        label: lab,
                      }))}
                      onChange={(e) => setLabel(e.value)}
                    ></DropDownGPT03>
                  </div>
                </div>
                {userData?.admin && !appState.hide_admin && (
                  <>
                    <div className="flex flex-row items-center gap-2 mt-3">
                      <CheckBoxGrey
                        onChange={() => setDevMode(!devMode)}
                        checked={devMode}
                      />
                      <div className="text-h3 text-black">Mode développement</div>
                    </div>
                    {devMode && (
                      <div className="flex flex-row items-center gap-2 mt-1">
                        <input
                          type="text"
                          value={devOecVmcUrl}
                          onChange={(e) => setDevOecVmcUrl(e.target.value)}
                          className="text-h3 border border-neutral-300 rounded-md px-2 py-1 w-full"
                          placeholder="URL OEC Forge backend"
                        />
                      </div>
                    )}
                  </>
                )}
                {folder.modif_thermal?.xml?.file && (
                  <div className="flex flex-row items-center gap-2 mt-2">
                    <CheckBoxGrey
                      onChange={() => {
                        setMAJ(!maj);
                      }}
                      checked={maj}
                    />
                    <div className="text-h3 text-black">
                      Utiliser le xml de la mise à jour
                    </div>
                  </div>
                )}
                <Space y={10} />
                {!no_document() && (
                  <div className="text-h3 text-shadow_50">
                    Aucun fichier n'a été trouvé dans le dossier ou les
                    documents associés pour être envoyé en annexe de la mission
                    oecvmc.
                  </div>
                )}
                {no_document() && (
                  <>
                    <div className="text-h3 text-shadow_50 mb-2 mt-2">
                      Sélectionnez les fichiers que vous voulez envoyer en
                      annexe de la mission oecvmc.
                    </div>
                    <div className="flex flex-col gap-1 ">
                      {vmc_documents.map((document, document_index) => (
                        <div
                          className="flex flex-row items-center gap-2"
                          key={document_index}
                        >
                          <div className="text-h3 w-c500 text-shadow_50">
                            {document.name}
                          </div>
                          <DropDownGPTS3
                            label="Sélectionner un fichier"
                            transparent={false}
                            className="w-fit ml-4"
                            value={document.file?.id || "none"}
                            items={[
                              { value: "none", label: "Aucun fichier" },
                              ...all_files.map((f) => ({
                                value: f.id,
                                label: f.name,
                              })),
                            ]}
                            onChange={(e) => {
                              let fresh_document = { ...document };
                              if (e.value === "none") {
                                fresh_document.file = null;
                              } else {
                                fresh_document.file = all_files.find(
                                  (f) => f.id === e.value
                                );
                              }
                              let new_documents = [...vmc_documents];
                              new_documents[document_index] = fresh_document;
                              setVmcDocuments(new_documents);
                            }}
                          ></DropDownGPTS3>
                        </div>
                      ))}
                    </div>
                    <div className="text-h3 text-shadow_50 mb-1 mt-3">
                      Fichiers supplémentaires (annexes)
                    </div>
                    <div className="flex flex-col gap-1 overflow-auto max-h-c200 border-1 rounded-md border-shadow_25 px-2 py-1">
                      {all_files.map((file, file_index) => {
                        const isSelected = extra_files.some((f) => f.id === file.id);
                        // Skip files already assigned to XML or VMC slots
                        const isAssigned = vmc_documents.some(
                          (doc) => doc.file?.id === file.id
                        );
                        if (isAssigned) return null;
                        return (
                          <div
                            key={file_index}
                            className="flex flex-row items-center gap-2"
                          >
                            <CheckBoxGrey
                              onChange={() => {
                                if (isSelected) {
                                  setExtraFiles(
                                    extra_files.filter((f) => f.id !== file.id)
                                  );
                                } else {
                                  setExtraFiles([...extra_files, file]);
                                }
                              }}
                              checked={isSelected}
                            />
                            <div className="text-h4 text-shadow_50">
                              {file.name.length > 60
                                ? file.name.slice(0, 60) + "..."
                                : file.name}
                            </div>
                          </div>
                        );
                      })}
                      {all_files.length === 0 && (
                        <div className="text-h4 text-shadow_25 py-1">
                          Aucun fichier disponible dans le dossier
                        </div>
                      )}
                    </div>
                    <div className="flex flex-row items-center gap-2 mt-2">
                      <label className="cursor-pointer flex flex-row items-center gap-2 text-h3 text-blue-600 hover:text-blue-800 border border-blue-200 bg-blue-50 rounded-md px-3 py-1">
                        <Icon1 icon_name="join" size={14} fill="#2563eb" />
                        {uploadingFiles ? <SmallSpinner /> : "Ajouter depuis l'ordinateur"}
                        <input
                          type="file"
                          multiple
                          accept=".pdf,.xml,.zip,.xlsx"
                          className="hidden"
                          disabled={uploadingFiles}
                          onChange={async (e) => {
                            const files = Array.from(e.target.files || []);
                            if (files.length === 0) return;
                            setUploadingFiles(true);
                            try {
                              const token = await getOrRefreshFirebaseToken();
                              for (const file of files) {
                                const formData = new FormData();
                                formData.append("file", file);
                                const resp = await fetch(
                                  prefix + "upload/dropzone-temporary",
                                  {
                                    method: "POST",
                                    headers: { Authorization: `Bearer ${token}` },
                                    body: formData,
                                  }
                                );
                                if (resp.ok) {
                                  const json = await resp.json();
                                  const data = json.data;
                                  setExtraFiles((prev) => [
                                    ...prev,
                                    {
                                      id: `dropzone-temporary/${file.name}`,
                                      name: file.name,
                                      url: data.url,
                                      octets: file.size,
                                    },
                                  ]);
                                }
                              }
                            } catch (err) {
                              console.error("Upload error:", err);
                            } finally {
                              setUploadingFiles(false);
                              e.target.value = "";
                            }
                          }}
                        />
                      </label>
                    </div>
                    {extra_files.length > 0 && (
                      <div className="flex flex-col gap-1 mt-1">
                        {extra_files.map((file, idx) => (
                          <div key={idx} className="flex flex-row items-center gap-2 text-h4 text-shadow_50">
                            <Icon1 icon_name="done2" size={14} fill="#22c55e" />
                            {file.name}
                            <button
                              className="text-red-400 hover:text-red-600 ml-1"
                              onClick={() =>
                                setExtraFiles(extra_files.filter((_, i) => i !== idx))
                              }
                            >
                              ✕
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                    {/* <div className="flex flex-col gap-1 overflow-auto max-h-c200 border-1 rounded-md border-shadow_25 px-2 py-1">
                      {folder.thermal?.files.map((file, file_index) => (
                        <div
                          className="flex flex-row items-center gap-2"
                          key={file_index}
                        >
                          <CheckBoxGrey
                            onChange={() => {
                              if (selected_files.includes(file)) {
                                setSelectedFiles(
                                  selected_files.filter((f) => f !== file)
                                );
                              } else {
                                setSelectedFiles([...selected_files, file]);
                              }
                            }}
                            checked={selected_files.includes(file)}
                          />
                          <div className="text-h4 text-shadow_50">
                            {file.name}
                          </div>
                        </div>
                      ))}
                      {documents.map((doc, index_doc) => (
                        <div key={index_doc}>
                          {doc.files?.map((file, file_index) => (
                            <div
                              key={file_index}
                              className="flex flex-row items-center gap-2"
                            >
                              <CheckBoxGrey
                                onChange={() => {
                                  if (selected_files.includes(file)) {
                                    setSelectedFiles(
                                      selected_files.filter((f) => f !== file)
                                    );
                                  } else {
                                    setSelectedFiles([...selected_files, file]);
                                  }
                                }}
                                checked={selected_files.includes(file)}
                              />
                              <div className="text-h4 text-shadow_50">
                                {file.name.length > 50
                                  ? file.name.slice(0, 50)
                                  : file.name}
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                      {bookshelf?.files_infiltrea?.length > 0 && (
                        <div className="border-l-2 border-blue-400 pl-2 p-1 bg-blue-50 rounded-lg">
                          <div className="text-h3 text-shadow_50 flex flex-row items-center gap-2 mb-2 ">
                            <Icon1
                              icon_name="bookshelf"
                              size={16}
                              fill="grey"
                            ></Icon1>{" "}
                            Bibliothèque OecVmc
                          </div>
                          <div className="flex flex-col gap-1 ">
                            {bookshelf?.files_infiltrea?.map(
                              (file, file_index) => (
                                <div
                                  key={file_index}
                                  className="flex flex-row items-start gap-2 "
                                >
                                  <CheckBoxGrey
                                    onChange={() => {
                                      if (selected_files.includes(file)) {
                                        setSelectedFiles(
                                          selected_files.filter(
                                            (f) => f !== file
                                          )
                                        );
                                      } else {
                                        setSelectedFiles([
                                          ...selected_files,
                                          file,
                                        ]);
                                      }
                                    }}
                                    checked={selected_files.includes(file)}
                                  />

                                  <div className="text-h4 text-shadow_50 ">
                                    {file.name.length > 50
                                      ? file.name.slice(0, 50)
                                      : file.name}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      )} */}
                    {/* </div>{" "} */}
                  </>
                )}{" "}
                {/* {no_xml() && (
                  <div className="text-h3 py-1 mt-4  px-2 w-fit bg-red-50 border-1 border-red-200 rounded-md text-red-500">
                    Aucun fichier XML n'a été trouvé dans le dossier donc si
                    vous générez une mission oecvmc, il n'y aura pas de fichier
                    XML associé.
                  </div>
                )}
                {!no_xml() && (
                  <div className="text-h3 py-1 mt-4  px-2 w-fit bg-green-50 border-1 border-green-200 rounded-md text-green-500">
                    Fichier XML trouvé dans le dossier.
                  </div>
                )}
                <Space y={5} /> */}
              </>
            )}
            {extractionLogs && (
              <div className="mt-2">
                <div className="text-h3 font-medium text-blue-600 mb-2">
                  Résultat de l'extraction
                </div>
                <div className="text-h4 bg-white border border-neutral-200 rounded-md p-3 font-mono overflow-auto" style={{ maxHeight: "400px" }}>
                  {renderLogLines(extractionLogs)}
                </div>
              </div>
            )}
          </div>
          <div className="border-t-1 w-full  p-4 flex-row flex justify-end">
            {loadingMission ? (
              <div className="flex flex-col w-full gap-2 items-center justify-center my-2">
                <div className="text-h3 text-shadow_50">
                  Création de la mission en cours...
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-1 overflow-hidden">
                  <div
                    className="bg-blue-400 h-1 rounded-full animate-pulse"
                    style={{
                      width: "100%",
                      animation: "loading-bar 2s ease-in-out infinite",
                    }}
                  ></div>
                </div>
                <style>{`
                  @keyframes loading-bar {
                    0% { width: 0%; }
                    50% { width: 80%; }
                    100% { width: 100%; }
                  }
                `}</style>
              </div>
            ) : extractionLogs ? (
              <PrimaryButton
                big={true}
                onClick={onClose}
                className="w-fit"
              >
                Fermer
              </PrimaryButton>
            ) : (
              <PrimaryButton
                big={true}
                onClick={handleCreateMission}
                className="  w-fit"
              >
                Générer Mission OecVmc
              </PrimaryButton>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default NewMission;
